<template>
  <div 
    :class="baseTextContainerClasses" 
    class="base-text-container"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  spacing: {
    type: String,
    default: "regular",
    validator: (value) => ["tight", "slim", "regular", "loose"].includes(value),
  },
});

const baseTextContainerClasses = computed(() => ({
  [`base-text-container--spacing-${props.spacing}`]: true,
}));
</script>

<style lang="scss">
@import "./base-text-container.scss";
</style>
